module.exports = __webpack_public_path__ + "static/media/loader.9bae66fb.png";